var Multisortable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_multisortable',
		divtable_zebra_order: null
	},

	initialize: function(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function() {
		var opts = this.options;
		var self = this;
		var _selects = this._element.getElements('select');
		var _divtable = this._element.getElement('.w_divtable');
		var first_load = true;

		this._trs = (_divtable) ? _divtable.getElements('.tr') : [];
		this._listing_trs = [];
		this._bld_trs = [];

		this._trs.each(function(_tr) {
			if (_tr.hasClass('_bld')) {
				self._bld_trs.push(_tr);
			} else if (!_tr.hasClass('adbld')) {
				self._listing_trs.push(_tr);
			}
		});

		_selects.each(function(_el) {
			_el.addEvent('change', function() {
				var url = _el.getElement(':selected').getAttribute('data-href');
				if (url && url != '') {
					window.location = url;
				}
			});
		});

		var divtable = Multisortable.divtable = new Divtable(_divtable, {'zebra_order': opts.divtable_zebra_order});
		var _st = this._element.getElement('.sort_tools');

		if (_st && _st.isDisplayed()) {
			var _toggle = _st.getElement('.w_toggle');
			var self = this;
			if (_toggle && _toggle.isDisplayed()) {
				new Toggle(_toggle, {
					divider: false,
					onToggle: function() {
						if (!_divtable || first_load) {
							return;
						}
						_divtable.toggleClass('_list_view');

						if (_divtable.hasClass('_list_view')) {
							_divtable.removeClass('_gallery_view');
							Cookie.write('crListingView', 'list');
						} else {
							_divtable.addClass('_gallery_view');
							Cookie.write('crListingView', 'gallery');
							if (!self.indicators_installed) {
								self.set_indicators(_divtable);
							}
						}
					}
				});

				var _gallery = _toggle.getElement('li.gallery');
				var _list = _toggle.getElement('li.list');

				if (Cookie.read('crListingView') === 'list') {
					if (_list) {
						_list.fireEvent('click', [_list]);
					}

					if (_divtable) {
						_divtable.addClass('_list_view');
						_divtable.removeClass('_gallery_view');
					}
				} else {
					if (_gallery) {
						_gallery.fireEvent('click', [_gallery]);
					}

					if (_divtable) {
						_divtable.removeClass('_list_view');
						_divtable.addClass('_gallery_view');
					}
				}
			} else {
				if (_divtable) {
					_divtable.removeClass('_list_view');
					_divtable.addClass('_gallery_view');
				}
			}
		} else {
			if (_divtable) {
				_divtable.removeClass('_list_view');
				_divtable.addClass('_gallery_view');
			}
		}

		var _sm_container = this._element.getElement('.lazy_pager');
		if (_sm_container) {
			var max_pages = _sm_container.getElement('ul').getAttribute('data-max-pages') || 1;
			var data_rpc = '';
			var _a = _sm_container.getElement('li.next a');

			if (_a) {
				data_rpc = _a.get('data-rpc') || _a.getProperty('href');
			}

			if (data_rpc != '') {
				data_rpc = data_rpc.replace(/&page=[0-9]/, '');
				var _show_more = new Element('.show_more', {'text': 'Show More'});
				_show_more.setProperties({ 'data-max-pages': max_pages, 'data-rpc': data_rpc + '&lazy=1&page=' });
				_show_more.inject(_sm_container, 'before');
				_sm_container.dispose();

				this.lazyloader = new RpcLazyLoader (_divtable.getElement('.tbody'), _show_more, {
					onAddNewContent: function(e) {
						divtable.add_new_rows(e);
						if (!document.getElement('.show_more') && _divtable.getElements('.tr').length < 500) {
							divtable.reinitialize();
						}

						e.each(function(_el) {
							var _pricehistory = _el.getElement('.w_blimp_pricehistory');
							if (_pricehistory) {
								new BlimpExtPricehistory(_pricehistory, {
									draggable: true,
									show_veil: true
								});
							}
						});
					}
				});
			}
		}

		if (_divtable) {
			first_load = false;
			if (_divtable.hasClass('_gallery_view')) {
				this.set_indicators(_divtable);
			}
		}
	},

	set_indicators: function(_divtable) {
		var opts = this.options;
		var self = this;
		var _indicators = this._element.getElements('.indicator');
		var _sorted_indicators = {};

		_indicators.each(function(_el) {
			var index = _el.getAttribute('data-bedroom-id') || _el.get('class');

			if (!_sorted_indicators[index]) {
				_sorted_indicators[index] = [];
			}
			_sorted_indicators[index].push(_el);
		});

		Object.each(_sorted_indicators, function(_inds, i) {
			var maxvalue = 0;
			var data_prop = _inds[0].getAttribute('data-property-indicator');

			if (data_prop) {
				maxvalue = _divtable.getElement('.tbody').getAttribute(data_prop) || 0;
			}

			if (opts.set_indicator_by_beds) {
				var _apartments_stats = self._element.getElement('#apartments_stats');

				if (_apartments_stats) {
					var data = JSONMOO.decode(_apartments_stats.get('html'), false);
					maxvalue = data.apartments[i] || 0;
				}
			}

			new Rater(_inds, {
				'property': 'data-value',
				'size': 'absolute',
				'animate': true,
				'type': 'horisontal',
				'duration': 1500,
				'equal_speed': true,
				'max_data': maxvalue.toInt(),
				'calculate_even_one_element': true
			});
		});
		Core.add_bars_support(this._element);
		this.indicators_installed = true;
	}
});

Multisortable.divtable;
Multisortable.lazyloader;
